<template>
  <div class="class_detail-root">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="goBack" class="nav-wrap">
        <p class="title">
          <span v-if="classInfo.is_special_train === 1"> 【快】 </span>
          {{ classInfo.name }}
        </p>
        <div class="nav-right" slot="right">
          <span
            v-if="Number(classInfo.isCanEdit) === 1"
            class="zuxie-btn inline-btn"
            @click="editClass"
            >修改/提交</span
          >
          <!--<span
            v-if="['Initiated'].includes(classInfo.status)"
            class="zuxie-btn edit-btn"
            @click="editStusInfo"
          >调整学员名单</span>-->
          <span
            v-if="Number(classInfo.isShowAdjust) === 1"
            class="zuxie-btn edit-btn"
            @click="editStusInfo"
            >调整学员名单</span
          >
          
          <button
            type="button"
            class="zuxie-btn zuxie-btn-primary student_num"
            @click="loadClassFile = true"
          >
            培训班附件下载
          </button>
          
          <!--<button-->
            <!--type="button"-->
            <!--:disabled="accBtnDis"-->
            <!--class="zuxie-btn zuxie-btn-primary student_num"-->
            <!--@click="loadStuAcc"-->
          <!--&gt;-->
            <!--学员帐号-->
          <!--</button>-->
          <!--<button-->
            <!--type="button"-->
            <!--:disabled="noticeBtnDis"-->
            <!--class="zuxie-btn zuxie-btn-primary load-btn"-->
            <!--@click="loadNotice('notification')"-->
            <!--v-if="classInfo.class_train_type === 'train' || classInfo.class_train_type === 'physical_train' || classInfo.class_train_type === 'goalkeeper_train'"-->
          <!--&gt;-->
            <!--录取通知-->
          <!--</button>-->
          <!--<button-->
            <!--type="button"-->
            <!--:disabled="noticeBtnDis"-->
            <!--class="zuxie-btn zuxie-btn-primary load-btn"-->
            <!--@click="loadNotice('manual')"-->
            <!--v-if="classInfo.class_train_type === 'train' || classInfo.class_train_type === 'physical_train' || classInfo.class_train_type === 'goalkeeper_train'"-->
          <!--&gt;-->
            <!--培训手册-->
          <!--</button>-->
        </div>
      </yioks-page-nav>

      <div class="class-info-wrap">
        <div class="info-box">
          <div class="show-wrap" @click="lookMoment()">
            <img
              :src="classInfo.moment_picture || momentCover"
              @error="momentImgLoadErr"
              class="picture"
            />
            <status-flag
              class="status-flat"
              :status="classInfo.status"
            ></status-flag>
            <!-- <div class="flag-wrap">
            <span class="flag-text">未开始</span>
            </div>-->
            <div class="btn wonder-btn">精彩瞬间</div>
          </div>
          <div class="detail-info">
            <template
              v-if="
                (classInfo.class_train_type === 'train' && ['A', 'B','PRO'].includes( classInfo.class_level)) || classInfo.class_train_type === 'physical_train' || classInfo.class_train_type === 'goalkeeper_train'
              "
            >
              <p>
                培训第一阶段：{{
                classInfo.dataPhase[0].start_date | time(false)
                }}
                至 {{ classInfo.dataPhase[0].end_date | time(false) }}
              </p>
              <p>
                培训第二阶段：{{
                classInfo.dataPhase[1].start_date | time(false)
                }}
                至 {{ classInfo.dataPhase[1].end_date | time(false) }}
              </p>
            </template>
            <template v-else>
              <p>
                培训日期：{{ classInfo.start_date | time(false) }} 至
                {{ classInfo.end_date | time(false) }}
              </p>
            </template>
            <p>
              <span
                >主讲师：{{ classInfo.teacher_off_name || "足协指派" }}</span
              >
              <span
                class="teacher_name"
                style="margin-left: 5px"
                v-if="
                  classInfo.teacher_name !== '' &&
                  classInfo.teacher_name != null
                "
                >助理讲师：{{ classInfo.teacher_name }}</span
              >
            </p>
            <p v-if="classInfo.lecturer_assistant_name">
              讲师助理：{{ classInfo.lecturer_assistant_name }}
            </p>
            <p v-if="classInfo.teacher_zhuli_names">
              讲师助理：{{ classInfo.teacher_zhuli_names }}
            </p>
            <template
              v-if="ifClassLevelShow(classInfo.class_level) && classInfo.class_train_type === 'train'"
            >
              <p>训练场地：{{ classInfo.training_address || "--" }}</p>
              <p>理论课场地：{{ classInfo.theory_address || "--" }}</p>
            </template>
            <!--<p>-->
            <!--<span style="cursor:pointer;color: #4cd964;text-decoration-line: underline" @click="showClassDetail=true">查看更多</span>-->
            <!--</p>-->
            <div
              class="wrapper-text"
              style="display: flex"
              v-if="classInfo.class_qr_code || classInfo.hours"
            >
              <div class="service-item" v-if="classInfo.class_qr_code">
                <!--style="cursor:pointer;margin-left:15px"-->
                <div style="display: flex; vertical-align: middle">
                  <span style="margin-right: 10px">班级群二维码:</span>
                  <v-icon
                    name="qrcode"
                    scale="1.15"
                    style="color: #4cd964"
                  ></v-icon>
                </div>
                <div class="item-common qrCode">
                  <div class="content">
                    <img :src="classInfo.class_qr_code" alt="" />
                  </div>
                </div>
              </div>
              <div class="service-item" v-if="classInfo.hours">
                <div
                  style="display: flex; vertical-align: middle; cursor: text"
                >
                  <span style="margin-right: 10px"
                    >学时: {{ classInfo.hours }}</span
                  >
                  <span style="margin-right: 10px" v-if="examine_way">考核方式: {{ examine_way}}</span>
                </div>
              </div>
            </div>
            <div class="wrapper-text" style="display: flex">
              <div
                @click="showClassDetail = true"
                style="
                  cursor: pointer;
                  color: #4cd964;
                  text-decoration-line: underline;
                  margin-right: 10px;
                "
              >
                查看培训班详细信息
              </div>
              <div class="service-item">
                <div
                  style="display: flex; vertical-align: middle; cursor: text"
                >
                  <span style="margin-right: 10px"
                    >培训班文件存档：
                    <span class="right-btn-span" @click="addFuncClass">
                      添加
                    </span>
                    <span class="right-btn-span" @click="viewDocumentsClass">
                      查看
                    </span></span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <template>
          <timetable
            class="timetable"
            :level="String(classInfo.class_level)"
            :class_train_type="String(classInfo.class_train_type)"
            :file-url="loadCurriUrl"
          >
            <div
              class="scoreBtns"
              v-if="
                classInfo.status === 'Complete' ||
                classInfo.status === 'ScoreAffirm'
              "
            >
              <div class="btn" key="action-btn" @click="downloadGrade" v-if="showDownScore">
                下载成绩
              </div>
              <div v-else key="default-btn" class="btn">下载成绩</div>
            </div>
            <div class="scoreBtns" v-if="classInfo.isShowScore">
              <div class="btn" @click="lookScore">查看成绩</div>
            </div>
          </timetable>
        </template>
      </div>
      <div class="group-list">
        <div class="left">
          <div class="group-wrap">
            <div
              v-for="(item, index) in groupList"
              :key="item.group_id"
              :class="['item', { active: activeIdx === index }]"
              @click="changeGroup(index)"
            >
              <p class="item-cont">{{ item.name }}</p>
            </div>
          </div>
        </div>
        <div class="right">
          <yioks-loading v-if="isLoadingStus"></yioks-loading>
          <template v-else>
            <div class="content-header">
              <div class="title">
                {{
                  groupList[activeIdx] ? groupList[activeIdx].name : ""
                }}学员信息
              </div>
              <div class="btn-group">
                <!--                <button type="button" :disabled='unconBtnDis' class=" zuxie-btn zuxie-btn-primary" v-if="classInfo.isShowStuExport === 1"  @click="loadUnConfirmStus">待确认学员</button>-->
                <!--<button type="button" class=" zuxie-btn zuxie-btn-primary"  @click="loadStuSignSheet">签到表</button>-->
                <!--<button type="button" class=" zuxie-btn zuxie-btn-primary"  @click="loadStuDressSize">学员尺码信息</button>-->
                <div class="zuxie-btn zuxie-btn-primary" @click="findStu">
                  学员资料总览
                </div>

                <div class="zuxie-btn zuxie-btn-primary" @click="adjustGroup">
                  调整分组
                </div>
              </div>
            </div>
            <div class="stu-list">
              <div class="scroll-wrap">
                <vue-scroll :ops="vuescrollOpt">
                  <div class="scroll-content">
                    <div
                      class="student"
                      v-for="item in stuList"
                      :key="item.user_id"
                    >
                      <img
                        :src="item.user_profile_picture || stuCoverDefault"
                        class="avator"
                        @error="profileImgLoadErr(item)"
                      />
                      <div class="desc">
                        <p class="part">
                          <span
                            class="part_rr"
                            :class="
                              item.enroll_type === 'make_up_exam'
                                ? 'showType'
                                : null
                            "
                            >姓名：{{ item.user_name }} <span v-if="!isFive && item.is_high_player" style="color:#FAF408;font-weight:bold" title="高水平职业球员认证">(G)</span></span
                          >
                          <span
                            v-if="item.enroll_type === 'make_up_exam'"
                            style="margin-right: 15px"
                            >(补考)</span
                          >
                          <span class="part_sex"
                            >性别：{{
                              item.gender === "Male" ? "男" : "女"
                            }}</span
                          >
                        </p>
                        <p class="part">
                          <span>手机：{{ item.mobile_phone }}</span>
                        </p>
                        <p class="part" v-if="item.is_fast" style="color:#4cd964;cursor:pointer">
                          <a :href="item.document_url" target="_blank">快速通道</a>
                        </p>
                      </div>
                      <div class="btn-group">
                        <div class="btns_box">
                          <span
                            class="inline-btn zuxie-btn min-btn"
                            @click="addFuncStudent(item)"
                            >添加文件存档</span
                          >
                          <span
                            class="inline-btn zuxie-btn min-btn"
                            @click="viewDocumentsStudent(item.id_number)"
                            >查看文件存档</span
                          >
                        </div>
                        <div class="btns_box">
                          <span
                            class="inline-btn zuxie-btn min-btn"
                            v-show="item.uid"
                            @click="trainView(item.uid)"
                            >个人简历</span
                          >
                          <span
                            class="inline-btn zuxie-btn min-btn"
                            @click="editStuHandle(item)"
                            >修改帐户</span
                          >
                        </div>
                        <div
                          :class="[
                            'btns_box',
                            classInfo.class_level !== 'D' && classInfo.class_level !== 'early'
                              ? 'inline_btns_wrap'
                              : 'block_btns_wrap',
                          ]"
                        >
                          <span
                            class="zuxie-btn min-btn"
                            @click="resumeView(item.uid)"
                            >本次培训</span
                          >
                          <span
                            class="zuxie-btn min-btn"
                            v-if="classInfo.class_level !== 'D' && classInfo.class_level !== 'early'"
                            @click="tranHisView(item.uid)"
                            >培训历程</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </vue-scroll>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <el-dialog
      @closed="dialogCloseHandle"
      :visible.sync="ifDialogShow"
      :close-on-click-modal="false"
      top="13vh"
      width="465px"
      class="yi-dialog-root class_edit-dialog"
    >
      <div class="slot-dialog-header" slot="title">
        <span class="title slot-header-item">修改帐户</span>
      </div>
      <div class="dialog-content">
        <el-form
          :model="formData"
          :rules="formRules"
          ref="dialogForm"
          label-width="130px"
          size="medium"
          class="edit-form"
        >
          <el-form-item label="证件号" prop="identity">
            <el-input
              v-model="formData.identity"
              type="text"
              disabled
              placeholder
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input
              v-model="formData.phone"
              type="text"
              placeholder="请填写用户名/手机号"
            ></el-input>
          </el-form-item>
          <el-form-item label="姓名" prop="user_name">
            <el-input
              v-model="formData.user_name"
              type="text"
              placeholder="请填写姓名"
              :disabled="not_change"
            ></el-input>
          </el-form-item>
          <el-form-item label="性别" prop="sex">
            <el-radio-group v-model="formData.sex" :disabled="true">
              <el-radio label="Male">男</el-radio>
              <el-radio label="Female">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="新密码" prop="password">
            <el-input
              v-model="formData.password"
              type="password"
              placeholder="不设置则不修改"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="password_affirm">
            <el-input
              v-model="formData.password_affirm"
              type="password"
              placeholder="请确认密码"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="footer-btn" slot="footer">
        <div class="btns">
          <!-- <div class="btn save"
               @click="saveStuInfo">保存
          </div>
          <div class="btn cancel"
               @click="dialogEsc">取消
          </div>-->
          <el-button type="primary" :loading="repeatSubmit" @click="saveStuInfo"
            >保存</el-button
          >
          <el-button type="danger" @click="dialogEsc">取消</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="detail-info-dia"
      title="详细信息"
      :visible.sync="ifDiaShow"
      :close-on-click-modal="false"
      width="750px"
      top="12vh"
    >
      <div class="scroll_wrap">
        <vue-scroll :ops="disScrollOpt" ref="vScroll">
          <div class="stu-info-box">
            <stu-detail-info :info="curStuInfo"></stu-detail-info>
          </div>
        </vue-scroll>
      </div>
    </el-dialog>
    <drag-group-dialog
      :list.sync="dragGroupList"
      :if-dia-show.sync="ifAdjustDiaShow"
      :class-level="classInfo.class_level"
      @save="dragSave"
    ></drag-group-dialog>
    <el-dialog
      width="350px"
      :visible.sync="verifyResult"
      custom-class="verify_result_dialog"
      :close-on-click-modal="false"
    >
      <div class="verifyResult">
        <p>审核结果：{{ verifyMsg.audit_status | verifyStatus }}</p>
        <p>
          <span>审核理由：</span>
          <span>{{ verifyMsg.audit_msg || "--" }}</span>
        </p>
      </div>
    </el-dialog>
    <class-info-detail
      v-if="showClassDetail"
      :isShow.sync="showClassDetail"
      :classInfo="classInfo"
      :examine_way="examine_way"
      :dataPhase="classInfo.dataPhase"
    ></class-info-detail>
    <template v-if="add_show_student">
      <add-dialog
        :showAddDialog="add_show_student"
        :Info="{
          name: add_name,
          id_number: add_id_number,
          mobile_phone: add_mobile_phone,
          object_type: 'student',
        }"
        @hideTips="hideAddDocumentTipsStudent"
      ></add-dialog>
    </template>
    <template v-if="add_show_class">
      <add-dialog
        :showAddDialog="add_show_class"
        :Info="{
          name: classInfo.name,
          id_number: classInfo.c_id,
          mobile_phone: '',
          object_type: 'class',
        }"
        @hideTips="hideAddDocumentTipsClass"
      ></add-dialog>
    </template>
    <div>
      <el-dialog
        title="学员信息"
        :visible.sync="isShowStuSimpleList"
        width="850px"
      >
        <!-- :before-close="dialogBeforeClose" -->
        <div class="stu-simple-list">
          <div class="search-box">
            <el-select v-model="stuName" placeholder="" @change="loadStudentsListSimple">
                  <el-option value="" label="全部学员"></el-option>
                  <el-option
                    v-for="item in studentData"
                    :key="item.uid"
                    :label="item.user_name"
                    :value="item.user_id">
                  </el-option>
            </el-select>
            <el-select v-model="sorting" placeholder=""  style="margin-left: 10px;">
                  <el-option
                    v-for="item in sortingList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
            </el-select>

          </div>

          <div class="stu-scroll-wrapper">
            <vue-scroll :ops="disScrollOpt">
              <div class="table-box">
                <div
                  v-for="(item, index) in studentsAllList"
                  :key="index"
                  class="stu-item"
                >
                  <div class="line">
                    <span
                      >姓名：

                      <span
                        class=""
                        >{{ item.name }}  <span v-if="!isFive && item.is_high_player" style="color:#f88594;font-weight:bold" title="高水平职业球员认证">(G)</span></span
                      >
                      （
                        <span class="suc btn" @click="findStuDetails(item)">详情</span>
                          <template v-if="isShowStuDocListExit">
                            <span style="margin: 0 5px;">/</span>
                            <span class="suc btn" @click="lookHistory(item.user_uuid)">历程</span>
                          </template>
                        ）
                      </span>
                      <span v-if="item.given_name_spell">拼音：{{ item.family_name_spell + '&nbsp;&nbsp;' + item.given_name_spell }}</span>
                      <span v-else >拼音：{{ '--' }}</span>
                      <span>年龄：{{ item.age || '--' }}</span>


                  </div>
                  <div class="line">
                    <span>性别：{{ item.gender | genderFilter }}</span>
                    <span>手机：{{ item.mobile_phone }}</span>
                    <span>证件号：{{ item.id_number }}</span>
                  </div>
                  <div class="line">
                    <span>单位名称：{{ item.take_unit_name | noFilter }}</span>
                  </div>
                  <!--<div class="line">-->
                    <!--<span class="t_pre" :data-pp="item.take_place"-->
                      <!--&gt;执教场所：{{ item.take_place | listFilter }}</span-->
                    <!--&gt;-->
                  <!--</div>-->
                  <div class="line">
                    <span class="t_pre"
                      >执教经历：{{ item.coach_experience | listFilter }}</span
                    >
                  </div>
                  <div class="line">
                    <span class="t_pre"
                      >运动经历：{{ item.sport_experience_new || '--' }}</span
                    >
                  </div>
                </div>
              </div>
            </vue-scroll>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- <div class="my-drawer">
      <el-drawer
        title=""
        custom-class="infoDrawer"
        :visible.sync="isShowStuDetails"
        direction="rtl"
        size="700px"
        destroy-on-close
        close-on-press-escape
        wrapperClosable
        :before-close="handleClose"
      >
        <div class="stu-info-wrapper">
          <vue-scroll :ops="disScrollOpt">
            <div class="scroll-content-ce">
              <stu-detail-info :info="curStuInfo"></stu-detail-info>
            </div>
          </vue-scroll>
        </div>
      </el-drawer>
    </div> -->
    <template v-if="loadClassFile">
      <loadClassFile
        :isShow.sync="loadClassFile"
        :classInfo="classInfo"
      ></loadClassFile>
    </template>
    <template v-if="isShowStuDetails">
        <drawer-stu-info :showDrawer.sync="isShowStuDetails" :info="curStuInfo"></drawer-stu-info>
      </template>
    <template v-if="showHistoryFromAll">
        <yioks-history-drawer
          :showHistory.sync="showHistoryFromAll"
          :coachHistoryInfo="coachHistoryInfo"
          :loading="historyLoading"
          :list="list"
          class="yioks-color"
        ></yioks-history-drawer>
    </template>
  </div>
</template>

<script>
import identify1 from "@/assets/images/vita/identify1.png";
import identify2 from "@/assets/images/vita/identify2.png";
import avatorImg from "@/assets/images/person.png";
import createScrollOpt from "@/assets/js/vuescrollOption";
import {
  getClassDetail,
  getStuList,
  editStu,
  loadStuAccountAjax,
  getClassDown,
  getClass_manual_down,
  loadStuDressSizeAjax,
  loadSignSheetAjax,
} from "@/api/agency/agency";
import {
  uploadSchedule,
  getStuListByClass,
} from "@/api/training_teacher/api";
import {
  getGroupingList,
  groupingStusAjax,
  unConfirmStus,
} from "@/api/common/api";
import { correctStatus } from "@/assets/js/apiStatus";
import commonFun from "@/assets/js/yioks";
// import draggable from "vuedraggable";
import momentCover from "@/assets/images/class_logo.png";
import stuCoverDefault from "@/assets/images/person.png";
import { getPwdSalt, getStuDetailInfo } from "@/api/common/api";
import { score_download } from "@/api/system_manager/api";
import { mapActions, mapGetters } from "vuex";
import { hex_hmac_sha256 } from "@/assets/js/sha";
const { mobile_phone, pwd, downfile } = commonFun;
const HOSTURL = process.env.VUE_APP_URL;
import { getStuHistoryTrian } from "@/api/system_manager/api";
import yioks from '@/assets/js/yioks';
import fiveMixins from '@/minix/fiveMixins';
import { experienceFilter } from "@/assets/js/yioksFilters";

// 将分组的数据转换为保存分组信息时，接口所需要的数据格式
/*const getGrouping = arr => {
  return arr.map(({ group_id, stu_list }) => {
    return {
      group_id,
      stu_id: stu_list.reduce((acc, { user_id }, index) => {
        return acc + user_id + (index === stu_list.length - 1 ? "" : ",");
      }, "")
    };
  });
};*/
export default {
  name: "TrainingClassDetail",
  mixins: [fiveMixins],
  data() {
    const formRules = {
      phone: [
        {
          required: true,
          validator: (rule, val, callback) => {
            if (mobile_phone(val)) {
              // callback();
              if (!this.phone_flag) {
                callback();
              } else {
                this.phone_flag = false;
                callback(new Error(this.phone_msg));
              }
            } else {
              callback(new Error("请输入有效的11位手机号"));
            }
          },
          trigger: "blur",
        },
      ],
      user_name: [
        { required: true, message: "请填写学员姓名", trigger: "blur" },
      ],
      sex: [{ required: true, message: "请选择学员性别", trigger: "change" }],
      password: [
        {
          validator: (rule, val, callback) => {
            if (val.trim() === "") {
              callback();
            } else {
              if (this.$yioks.pwd(val)) {
                callback();
              } else {
                callback(new Error("8—16位字母（区分大小写）和数字组合"));
              }
            }
          },
          trigger: "blur",
        },
      ],
      password_affirm: [
        {
          validator: (rule, val, callback) => {
            if (val.trim() !== this.formData.password.trim()) {
              callback(new Error("两次输入密码不一致"));
            }
            if (val.trim() === "") {
              callback();
            } else {
              if (this.$yioks.pwd(val)) {
                callback();
              } else {
                callback(new Error("8—16位字母（区分大小写）和数字组合"));
              }
            }
          },
          trigger: "blur",
        },
      ],
    };
    return {
      loadClassFile: false,
      accBtnDis: false,
      not_change: false,
      showClassDetail: false,
      noticeBtnDis: false,
      unconBtnDis: false,
      add_show_class: false,
      add_show_student: false,
      add_id_number: "",
      add_name: "",
      add_mobile_phone: "",
      disScrollOpt: createScrollOpt(true),
      repeatSubmit: false,
      showDownScore: true,
      classId: this.$route.query.classId,
      momentCover,
      stuCoverDefault,
      isCurriLoadSuc: true,
      formData: {
        userId: "",
        user_name: "",
        phone: "",
        sex: "",
        password: "",
        password_affirm: "",
        identity: "",
      },
      phone_msg: "",
      examine_way: "",
      phone_flag: false,
      formRules,
      ifDialogShow: false,
      ifAdjustDiaShow: false,
      // 是否正在加载学员信息列表
      isLoadingStus: false,
      classInfo: {},
      groupList: [],
      dragGroupList: [],
      stuList: [],
      // 当前组别索引
      activeIdx: 0,
      loadCurriUrl: "",
      dragItem: {}, // 被拖动这一项的数据
      vuescrollOpt: createScrollOpt(),
      verifyResult: false,
      verifyMsg: {},
      ifDiaShow: false,
      curStuInfo: {
        studentSingnInfo: {},
        language_list: [],
        academic_data: [],
        coach_data: [],
        experience_data: [],
        experience_data_not: [],
        playing_data: [],
      },
      isShowStuSimpleList: false,
      isShowStuDetails: false,
      studentsAllList: [], //

      showHistoryFromAll: false,
      coachHistoryInfo: {
        coachUser: {},
        ranks: [],
        certificates: [],
        achievemens: [],
        rankList: [],
      },
      historyLoading: false,
      list: [],
      stuName: '',
      studentData: [],
      sorting: JSON.stringify({ family_spell: 'ASC', age: ''}),  // 排序
      search_age: '',
      search_family_spell: 'ASC',
      sortingList: [
        { id:"0", label: '年龄正序', value: JSON.stringify({ family_spell: '', age: 'ASC'}) },
        { id:"1", label: '年龄倒序', value: JSON.stringify({ family_spell: '', age: 'DESC'}) },
        { id:"2", label: '拼音正序', value: JSON.stringify({ family_spell: 'ASC', age: ''}) },
        { id:"3", label: '拼音倒序', value: JSON.stringify({ family_spell: 'DESC', age: ''}) },
      ],

    };
  },
  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),
    "yioks-loading": () => import("@/components/Loading/Loading"),
    "v-icon": () => import("vue-awesome/components/Icon"),
    // "drag-group-dialog": () => import("@/components/DragGroup/DragGroup"),
    "drag-group-dialog": () => import("@/components/DragGroup/drag-stus"),
    "status-flag": () => import("@/components/Tips/Status"),
    timetable: () => import("@/components/Timetable/Timetable"),
    "stu-detail-info": () => import("@/components/StuDeatilInfo/StuDeatilInfo"),
    "add-dialog": () => import("@/views/Documents/components/AddDialog"),
    "class-info-detail": () =>
      import("@/components/ClassInfoBox/classInfoDetail"),
      "yioks-history-drawer": () => import("@/components/History/history-drawer"),
      "drawer-stu-info": () => import("@/components/Drawer/stuDrawer"),
      "loadClassFile": () => import("@/components/ClassInfoBox/classFileDownLoad"),
  },
  filters: {
    verifyStatus(status) {
      const statusHash = {
        pass: "通过",
        repulse: "拒绝",
        pause: "暂停",
      };
      return !status ? "--" : statusHash[status];
    },
    genderFilter(val) {
      switch (val) {
        case "Male":
          return "男";
        case "Female":
          return "女";
        default:
          return "--";
      }
    },
    noFilter(val) {
      return val ? val : "--";
    },
    // listFilter(val) {
    //   if (val) {
    //     if (val !== "无" && val !== '"无"' && val !== "'无'") {
    //       try {
    //         let arr = JSON.parse(val);
    //         let list = arr.map((item) => {
    //           return item.join("/");
    //         });
    //         return list.join(",");
    //       } catch(err) {
    //         console.error('JSON String is error for unknnow reason:', val)
    //         return val
    //       }
    //     } else {
    //       return val;
    //     }
    //   } else {
    //     return "--";
    //   }
    // },

    listFilter: experienceFilter,
  },
  created() {
    this.setData();
    this.getClassInfo();
    this.groupListInfo(() => {
      this.changeQuery();
    });
    this.loadStudentsListSimple();
    // this.actionGetClassInfo()
  },
  methods: {
    viewDocumentsStudent(id_number) {
      this.$router.push({
        path: "documents",
        query: {
          id_number: id_number,
        },
      });
    },
    addFuncStudent(item) {
      this.add_id_number = item.id_number;
      this.add_name = item.user_name;
      this.add_mobile_phone = item.mobile_phone;
      this.add_show_student = true;
    },
    hideAddDocumentTipsStudent(bool, flag) {
      this.add_show_student = bool;
      if (flag) {
        this.$message.success("添加成功！");
      }
    },
    viewDocumentsClass() {
      this.$router.push({
        path: "documents",
        query: {
          id_number: this.classId,
          idx: 1,
          object_type: "class",
        },
      });
    },
    addFuncClass() {
      this.add_show_class = true;
    },
    hideAddDocumentTipsClass(bool, flag) {
      this.add_show_class = bool;
      if (flag) {
        this.$message.success("添加成功！");
      }
    },
    trainView(uuid) {
      this.ifDiaShow = true;
      this.getDetailInfo(uuid);
    },
    getDetailInfo(uuid) {
      getStuDetailInfo({ uuid, c_id: this.classId }).then(({ data }) => {
        if (data.status === 0) {
          const { result } = data;
          this.curStuInfo.studentSingnInfo = {
            ...result.studentSingnInfo,
            id_card_photo_front: result.studentSingnInfo.id_card_photo_front
              ? HOSTURL + result.studentSingnInfo.id_card_photo_front
              : identify1,
            id_card_photo_verso: result.studentSingnInfo.id_card_photo_verso
              ? HOSTURL + result.studentSingnInfo.id_card_photo_verso
              : identify2,
            profile_picture: result.studentSingnInfo.profile_picture
              ? HOSTURL + result.studentSingnInfo.profile_picture
              : avatorImg,
          };
          for (const key in this.studentSingnInfo) {
            if (this.studentSingnInfo.hasOwnProperty(key)) {
              const element = this.studentSingnInfo[key];
              this.studentSingnInfo[key] = element || "--";
            }
          }

          this.curStuInfo.language_list = [...result.language_list];
          this.curStuInfo.academic_data = [...result.academic_data];
          this.curStuInfo.coach_data = [...result.coach_data];
          this.curStuInfo.experience_data = [...result.experience_data];
          this.curStuInfo.experience_data_not = [...result.experience_data_not];
          this.curStuInfo.playing_data = [...result.playing_data];
          if (this.curStuInfo.studentSingnInfo.student_information === 'Active' && !this.curStuInfo.studentSingnInfo.total_score && result.experience_data_backup.length > 0 ){
            this.curStuInfo.experience_data = [...result.experience_data_backup];
          }
          // experienceFilter替代了部分数据

        } else {
        }
      });
    },
    resumeView(u_id) {
      this.$router.push({
        path: "tea_sd",
        query: {
          c_id: this.classId,
          u_id,
        },
      });
    },
    tranHisView(u_id) {
      this.$router.push({
        name: "orgTrainingHis",
        query: {
          c_id: this.classId,
          u_id,
        },
      });
    },
    ...mapActions(["actionStoreClassData"]),
    setData() {
      const { idx } = this.$route.query;
      idx && (this.activeIdx = Number(idx));
    },
    dragSave(gList) {
      this.ifAdjustDiaShow = false;
      groupingStusAjax({
        // data_list: JSON.stringify(getGrouping(gList)),
        data_list: JSON.stringify(gList),
        c_id: this.classId,
      })
        .then(({ data }) => {
          if (data.status === correctStatus) {
            // 保存成功，重新请求接口，并更新数据
            this.getClassInfo();
            this.groupListInfo(() => {
              this.changeQuery();
            });
            this.$message.success("调整分组成功");
          } else {
            this.$message.error(`调整分组保存失败，${data.msg}`);
          }
        })
        .catch((err) => {
          this.$message.error(`调整分组保存失败，${data.msg}`);
        });
    },
    // 触发 vuex 中改变培训班数据的 action
    actionGetClassInfo() {
      this.actionStoreClassData(this.classId).then(() => {
        this.getGroupStuList();
      });
    },
    momentImgLoadErr() {
      this.classInfo.moment_picture = this.momentCover;
    },
    // 学员头像图片加载失败
    profileImgLoadErr(item) {
      const idx = this.stuList.indexOf(item);
      if (idx === -1) return;
      this.$set(
        this.stuList[idx],
        "user_profile_picture",
        this.stuCoverDefault
      );
    },
    // 下载学员帐号时执行
    loadStuAcc() {
      if (this.accBtnDis) return;
      this.accBtnDis = true;
      loadStuAccountAjax({ c_id: this.classId, type: "notification" }).then(
        ({ data }) => {
          if (data.status === correctStatus) {
            downfile(data.result.file_url);
          } else {
            this.$message.error(`下载失败, ${data.msg}`);
          }
          this.accBtnDis = false;
        }
      );
    },
    // 获取培训班分组列表
    groupListInfo(dosome = () => {}) {
      getGroupingList({ c_id: this.classId }).then(({ data }) => {
        if (data.status === correctStatus) {
          const { list } = data.result;
          this.groupList = [...list];
          this.dragGroupList = [...list];
          dosome();
        }
      });
    },
    // 获取培训班基本信息
    getClassInfo() {
      getClassDetail({
        c_id: this.classId,
      }).then(({ data }) => {
        if (data.status === correctStatus) {
          const {
            result: {
              msg_info,
              class_info,
              dataPhase,
              isShowAdjust,
              examine_way,
              isCanEdit,
              isShowAuditMsg,
              isShowScore,
              isShowStuExport,
            },
          } = data;
          this.studentData = data.result.student_data;
          // this.groupList = [...group_list];
          this.loadCurriUrl = class_info.timetable_picture;
          this.examine_way = examine_way;
          this.classInfo = {
            ...class_info,
            isShowAdjust,
            dataPhase,
            isCanEdit,
            isShowAuditMsg,
            isShowScore,
            isShowStuExport,
            moment_picture:
              class_info.moment_picture && HOSTURL + class_info.moment_picture,
            // timetable_picture: this.loadCurriUrl && HOSTURL + this.loadCurriUrl
          };
          const type_list = [
            "Finalised",
            "ScoreAudit",
            "ScoreRefused",
            "ScoreAffirm",
            "Complete",
          ];
          this.not_change = type_list.includes(this.classInfo.status)
            ? true
            : false;
          Number(isShowAuditMsg) === 1 && (this.verifyMsg = msg_info);
        }
      });
    },
    // 获取培训班中某个小组的学员列表信息
    getGroupStuList() {
      this.stuList = this.groupList[this.activeIdx].stu_list;
      this.isLoadingStus = false;
    },
    dialogCloseHandle() {
      this.$refs["dialogForm"].resetFields();
    },
    dialogEsc() {
      this.ifDialogShow = false;
    },
    lookMoment() {
      this.$router.push({
        name: "ClassMoment",
        params: { classId: this.classId },
      });
    },
    // 点击编辑资料，弹出弹窗并回显
    editStuHandle(stuInfo) {
      this.formData.userId = stuInfo.user_id;
      this.formData.user_name = stuInfo.user_name;
      this.formData.phone = stuInfo.mobile_phone;
      this.formData.sex = stuInfo.gender;
      this.formData.password = "";
      this.formData.identity = stuInfo.id_number;
      this.ifDialogShow = true;
    },
    // 编辑学员个人信息
    editStuData(editData) {
      editStu({
        user_id: editData.userId,
        name: editData.user_name,
        gender: editData.sex,
        mobile_phone: editData.phone,
        password: editData.password,
        password_affirm: editData.password_affirm,
        regist_salt: editData.regist_salt,
        // id_number: editData.identity,
      })
        .then(({ data }) => {
          if (data.status === correctStatus) {
            // this.$message.success("修改成功");
            this.ifDialogShow = false;
            this.groupListInfo(this.getGroupStuList);
          } else if (data.status === 405 || data.status === 114) {
            this.phone_msg = data.msg;
            this.phone_flag = true;
            this.$refs["dialogForm"].validateField("phone");
          } else {
            this.$message.error(`编辑失败，${data.msg}`);
          }
          this.repeatSubmit = false;
          //        this.ifDialogShow = false;
        })
        .catch((err) => {
          this.repeatSubmit = false;
          console.error(err);
        });
    },
    // 保存编辑的学员资料
    saveStuInfo() {
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      this.$refs["dialogForm"].validate((valid) => {
        if (valid) {
          const { formData } = this;
          if (formData.password !== "") {
            getPwdSalt()
              .then(({ data }) => {
                if (data.status === correctStatus) {
                  const { regist_salt } = data.result.data;
                  const password = hex_hmac_sha256(
                    regist_salt,
                    formData.password.toString()
                  ).toUpperCase();
                  const password_affirm = hex_hmac_sha256(
                    regist_salt,
                    formData.password_affirm.toString()
                  ).toUpperCase();
                  const editData = {
                    ...formData,
                    password,
                    regist_salt,
                    password_affirm,
                  };
                  // console.log("到底拿到盐没有啊 ~ ", regist_salt, password);
                  this.editStuData(editData);
                }
              })
              .catch((err) => {
                this.repeatSubmit = false;
                console.error(err);
              });
          } else {
            this.editStuData(formData);
          }
        } else {
          this.repeatSubmit = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 查看组中学员教案
    viewStu(item) {
      this.$router.push({
        name: "StuTutorial",
        params: { classId: this.classId },
        query: { user_id: item.user_id },
      });
    },
    
    // 下载待确认学员
    loadUnConfirmStus() {
      if (this.unconBtnDis) return;
      this.unconBtnDis = true;
      unConfirmStus({ c_id: this.classId }).then(({ data }) => {
        if (data.status === correctStatus) {
          downfile(data.result.file_url);
        } else {
          this.$message.error(`下载失败, ${data.msg}`);
        }
        this.unconBtnDis = false;
      });
    },
    
    // 修改培训班信息
    editClass() {
      if(this.isFive) {
        this.$router.push({
          name: "EditTrainingClassFive",
          params: { classId: this.classId, status: this.classInfo.status },
        });
      } else {
        this.$router.push({
          name: "EditTrainingClass",
          params: { classId: this.classId, status: this.classInfo.status },
        });
      }

    },
    // 调整学员名单🧐
    editStusInfo() {
      this.$router.push({
        name: "EditStusInfo",
        params: { classId: this.classId },
      });
    },
    // 切换组
    changeGroup(idx) {
      this.activeIdx = idx;
      this.changeQuery();
    },
    changeQuery() {
      this.activeIdx =
        this.activeIdx > this.groupList.length - 1 ? 0 : this.activeIdx;
      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          idx: this.activeIdx,
          t: new Date().getTime()
        },
      });
      this.getGroupStuList();
    },
    goBack() {
      /*this.$router.push({
        name: "TrainingCourseManager"
      });*/
      this.$router.go(-1);
    },
    lookScore() {
      this.$router.push({
        path: "look_score",
        query: {
          c_id: this.classId,
        },
      });
    },
    downloadGrade() {
      this.showDownScore = false;
      score_download({
        c_id: this.classId,
      })
        .then((res) => {
          if (Number(res.data.status) === 0) {
            const { file_url } = res.data.result;
            downfile(file_url);
            this.showDownScore = true;
          } else {
            this.showDownScore = true;
          }
        })
        .catch((err) => {
          this.showDownScore = true;
        });
    },
    adjustGroup() {
      this.ifAdjustDiaShow = true;
      this.dragGroupList = this.groupList;
    },

    findStu() {
      if(this.stuName) {
        this.stuName = '';
        this.loadStudentsListSimple()
      }
      this.isShowStuSimpleList = true;
      // this.isShowStuDetails = true;
    },

    /* 打开侧边学员简历 */
    findStuDetails(row) {
      const { user_uuid: uuid } = row;
      this.isShowStuDetails = true;
      this.getDetailInfo(uuid);
    },

    /* 获取学员列表 */
    loadStudentsListSimple() {
      const paramsData = {
        c_id: this.classId,
        user_id: this.stuName,
        age: this.search_age,
        family_spell: this.search_family_spell,
      };
      getStuListByClass(paramsData)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          this.studentsAllList = data.result.infoList.map((item) => {
            const {
              name,
              gender,
              mobile_phone,
              id_number,
              club_name,
              take_place,
              coach_experience,
              sport_experience,
              sport_experience_new,
              user_uuid,
              family_name_spell,
              given_name_spell,
              birthday,
              is_high_player,
              take_unit_name,
            } = item;
            const age = yioks.parse_age_bg_birthday(birthday);
            return {
              name,
              gender,
              mobile_phone,
              id_number,
              club_name,
              take_place,
              coach_experience,
              sport_experience,
              sport_experience_new,
              user_uuid,
              age,
              family_name_spell,
              given_name_spell,
              is_high_player,
              take_unit_name,
            };
          });
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
    handleClose(done) {
      // console.log("done is active", done);
      done();
    },
    // 打开历史
    lookHistory(uid){
      // if (this.showHistory) return;
      // this.showHistory=true;
      if (this.showHistoryFromAll) return;
      this.showHistoryFromAll=true;
      this.getStuHistoryTrianList(uid)
    },

    // 获取历程
    getStuHistoryTrianList(uid) {
      this.list = [];
      this.historyLoading = true;
      getStuHistoryTrian({
        uid,
      })
        .then((res) => {
          const { result } = res.data;

          if (result.coachHistoryInfo) {
            const { coachUser, ranks, certificates, achievemens, score } =
              result.coachHistoryInfo;
            if (coachUser) this.coachHistoryInfo.coachUser = coachUser; // 获取用户信息
            if (ranks) this.coachHistoryInfo.ranks = ranks; // 获取等级
            if (certificates) this.coachHistoryInfo.certificates = certificates; //获取证书
            if (achievemens) this.coachHistoryInfo.achievemens = achievemens; //获取成绩信息
            // 处理证书
            let certificateInfo = {};
            if (certificates.length > 0) {
              for (let i = 0; i < certificates.length; i++) {
                const { rankId } = certificates[i];
                certificateInfo[rankId] = certificates[i];
              }
            }
            // 处理成绩
            let achievemensInfo = {};
            if (achievemens.length > 0) {
              for (let i = 0; i < achievemens.length; i++) {
                const { rankId } = achievemens[i];
                achievemensInfo[rankId] = achievemens[i];
              }
            }
            // 合并成绩
            if (ranks.length > 0) {
              for (let j = 0; j < ranks.length; j++) {
                const { id } = ranks[j];
                if (score && score[achievemensInfo[id]["id"]]) {
                  ranks[j]["score"] = score[achievemensInfo[id]["id"]];
                }
                ranks[j].is_old = 1;
                if (certificateInfo[id]) {
                  const {
                    certificateNum,
                    certificateDate,
                    validityStart,
                    certificateUrl,
                  } = certificateInfo[id];
                  ranks[j].certificateNum = certificateNum;
                  ranks[j].certificateDate = certificateDate;
                  ranks[j].validityStart = validityStart;
                  if (certificateUrl) ranks[j].certificateUrl = certificateUrl;
                }
                if (achievemensInfo[id]) {
                  const {
                    classAddress,
                    classEnd,
                    classStart,
                    lecturerName,
                    classUid,
                    continueCumulativeHours,
                  } = achievemensInfo[id];
                  ranks[j].classAddress = classAddress;
                  ranks[j].classEnd = classEnd;
                  ranks[j].classStart = classStart;
                  ranks[j].lecturerName = lecturerName;
                  ranks[j].classUid = classUid;
                  ranks[j].end_date = new Date(classEnd).getTime();
                  ranks[j].continueCumulativeHours = continueCumulativeHours;
                  this.list.push(ranks[j]);
                }
              }
            }
            if (this.list)
              this.list = this.list.sort((pre, next) => {
                return next.end_date - pre.end_date;
              });
          }
          this.historyLoading = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },

  },
  computed: {
    ...mapGetters(["getStoreClassData"]),
    isShowStuDocListExit() {
      const { class_level, class_train_type }  = this.classInfo;
      if((class_level === 'D' && class_train_type === "train") || class_level === 'early') {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    getStoreClassData: {
      handler(val) {
        // this.groupList = val.groupList || [];
        // this.loadCurriUrl = val.loadCurriUrl || ''
        // this.classInfo = val.classInfo || {}
      },
      immediate: true,
      deep: true,
    },

    sorting(newVal, oldVal) {
      if(!newVal) {
        this.search_age = '';
        this.search_family_spell = '';
      } else {
        const { family_spell, age } = JSON.parse(newVal);
        this.search_age = age;
        this.search_family_spell = family_spell;
      }
      this.loadStudentsListSimple();
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
@import '~@/assets/css/mixin'
@import '~@/assets/css/linDialog'
$form_input_h = 32px
$form_input_w = 200px
$form_input_bc = #999999
.right-btn
  position absolute
  right 0
  top -20px
.right-btn-span
  color $color_suc
  border-bottom 1px solid
  cursor pointer
.right-btn-span:first-child
  margin-right 10px
.class_detail-root
  zuxie-page-root()
  .detail-info-dia
    .scroll_wrap
      display block
      height 530px
      overflow hidden
      position relative
      .stu-info-box
        display block
        padding 0 15px
        font-size $font_size_medium
  .main-content-wrap
    color $color_white
    font-size $font_size_medium
    line-height inherit
    .nav-wrap
      margin-bottom 25px
      .title
        line-height 1.2
        font-size $font_size_big
      .nav-right
        .zuxie-btn
          background-color $color_primary
          &+.zuxie-btn
            margin-left 12px
    .class-info-wrap
      position relative
      display flex
      align-items flex-start
      margin-bottom 10px
      padding 0 20px
      background-color $block_bg_color_base
      .timetable
        /* margin-right 20px */
      .info-box
        padding 20px 0 10px 20px
        flex 1
        display flex
        align-items flex-start
        .show-wrap
          flex none
          position relative
          z-index 10
          width 150px
          height 115px
          margin-right 15px
          cursor pointer
          .picture
            display block
            width 100%
            height 100%
          .status-flat
            left 6px
          .flag-wrap
            position absolute
            z-index 100
            font-size 12px
            left 10px
            top 0
            &:after
              content ''
              position absolute
              left 0
              bottom 0
              transform translate(0, 100%)
              z-index 1
              width 0
              height 0
              overflow hidden
              border-style solid
              border-width 11px
              border-color transparent
              border-top-color $color_primary
            .flag-text
              display block
              width 22px
              height 55px
              background-color $color_primary
              line-height @width
              writing-mode vertical-lr
              text-align center
              letter-spacing 1px
          .wonder-btn
            position absolute
            z-index 200
            width 100px
            line-height 30px
            text-align center
            font-size 14px
            background-color $color_err
            bottom 2px
            left 0
            right 0
            margin 0 auto
        .detail-info
          font-size $font_size_medium
          flex 1
          .info-item
            margin-bottom 0.35em
            .teacher_name
              margin-left 20px
          .service-item
            position relative
            cursor pointer
            margin-right 20px
            .item-common
              display none
              position absolute
              z-index 10000
              top -200px
              right -100px
              width 250px
              height 250px
              .content
                padding 10px
                justify-content center
                align-items center
                display flex
                background-color rgba(0, 0, 0, 0.7)
                img
                  height 100%
                  width 100%
                  padding 5px
                  border 1px solid #ffffff
            &:hover
              .qrCode
                display block
      .scoreBtns
        width 100%
        border 1px dashed $color_white
        height 100%
        border-radius 5px
        margin-bottom 5px
        display flex
        justify-content center
        align-items center
        .btn
          width 80%
          height 40px
          display flex
          justify-content center
          align-items center
          font-size $font_size_medium
          cursor pointer
          margin 0 5px
          border-radius 5px
          background-color $color_suc
    .group-list
      // display block
      display flex
      justify-content space-between
      align-items stretch
      width 100%
      height 460px
      .left
        // float left
        width 195px
        // flex-basis @width
        // height 100%
        background-color $block_bg_color_base
        .group-wrap
          // display flex
          display block
          width 100%
          height 100%
          // flex-flow column nowrap
          // align-items stretch
          // justify-content space-between
          padding 0px 30px
          .item
            display flex
            align-items center
            justify-content center
            text-align center
            // line-height 36px
            height 36px
            cursor pointer
            margin 12px 0
            &.active
              background-color $color_suc
        .scroll-wrap
          display block
          width 100%
          height 100%
          /* padding-bottom 20px */
          padding-top 5px
          overflow hidden
          .happy-scroll-strip--vertical
            right 4px
          .scroll-content
            display block
            padding 0 30px
            .item
              display block
            .item-cont
              display block
              text-align center
              line-height 36px
              cursor pointer
              &.active
                background-color $color_suc
      .right
        position relative
        z-index 111
        // float right
        width 685px
        flex-basis @width
        // height 100%
        background-color $block_bg_color_base
        display flex
        flex-direction column
        padding 20px 0 10px
        color $color_white
        .content-header
          display flex
          flex none
          align-items center
          margin-right 20px
          margin-left 20px
          padding-bottom 10px
          border-bottom 1px solid $color_white
          .title
            font-size 20px
            line-height 1
            flex 1
          .btn-group
            flex none
            .zuxie-btn
              &+.zuxie-btn
                margin-left 10px
        .stu-list
          display block
          height 375px
          // flex 1
          overflow hidden
          .scroll-wrap
            display block
            width 100%
            height 100%
            padding-top 5px
            overflow hidden
            .scroll-content
              display block
              padding 0 20px
              font-size $font_size_medium
              .student
                display flex
                align-items center
                padding-bottom 5px
                margin-right 10px
                border-bottom 1px solid $color_white
                &+.student
                  margin-top 5px
                .avator
                  width 80px
                  height 80px
                  border-radius 50%
                  margin-right 20px
                .desc
                  flex 1
                  padding-right 10px
                  .part
                    display flex
                    // align-items flex-end
                  .part:not(:last-child)
                    margin-bottom 1em
                  .part_rr
                    margin-right 15px
                    word-break break-all
                    word-wrap break-word
                  .showType
                    margin-right 0
                  .part_sex
                    flex none
                .btn-group
                  .zuxie-btn
                    background none
                    border 1px solid
                    &:hover
                      background $color_primary
                      // border none
                  .btns_box
                    &+.btns_box
                      margin-top 6px
                    &.block_btns_wrap
                      .zuxie-btn
                        width 100%
                    .zuxie-btn
                      &+.zuxie-btn
                        margin-left 8px
                    .min-btn
                      min-width 118px
                      padding 10px 10px
  .footer-btn
    .btns
      display flex
      justify-content center
      color $color_white
      .el-button--danger
        background-color $color_err
      .btn
        padding 10px 25px
        margin 0 10px
        border-radius 4px
        cursor pointer
        user-select none
      .save
        background-color $color_suc
      .cancel
        background-color $color_err
.suc
  color $color_suc
</style>

<style lang="stylus" scoped>
.scoreBtns
  width 100%
  border 1px dashed #fff
  height 100%
  border-radius 5px
  margin-bottom 5px
  display flex
  justify-content center
  align-items center
  .btn
    width 80%
    height 40px
    display flex
    justify-content center
    align-items center
    font-size $font_size_medium
    cursor pointer
    margin 0 5px
    border-radius 5px
    background-color $color_suc
</style>

<style lang="stylus" scoped>
.stu-simple-list
  font-size 16px
  .search-box
    padding 10px 10px
    border-bottom 1px solid #666
    margin 0 20px 10px
  .stu-scroll-wrapper
    height 530px
    margin-left 5px
    .table-box
      margin 0 25px
      .stu-item
        margin-bottom 10px
        box-sizing border-box
        padding-bottom 10px
        border-bottom 2px dashed #e6a23c
        &:last-child
          margin-bottom 0px
          border-bottom none
        .line
          border 1px solid #ccc
          border-bottom none
          line-height 28px
          padding 5px 10px
          display flex
          justify-content space-between
          &:last-child
            margin-bottom 0px
            border 1px solid #ccc
.mr10
  margin-right 10px
.btn
  cursor pointer
  user-select none
.stu-info-wrapper
  height 90vh
  .scroll-content-ce
    margin 0 25px
</style>


<style lang="stylus" >
.my-drawer
  position absolute
  top 0
  right 0
  .infoDrawer
    color #666
    padding-left 10px
    position absolute
    box-sizing border-box
    background-color #fff
    display flex
    flex-direction column
    box-shadow 0 8px 10px -5px rgba(0, 0, 0, 0.2), 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12)
    overflow hidden
    right 0
    height 100vh
    .el-drawer__header
      align-items center
      justify-content space-between
      color #72767b
      display flex
      padding 20px 20px 0
      .el-drawer__close-btn
        border none
        cursor pointer
        font-size 20px
        color inherit
        background-color transparent
</style>


<style lang="stylus" scoped>
@media screen and (max-height 900px)
  .mainContentWrap
    height 630px
</style>


